import React,{useState,useEffect} from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Card,Box, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import NumberFormat from 'react-number-format';
import TablaAvSecc from './TablaAvSecc';
const useStyles = makeStyles({
    estiloCard:{
      width: '28rem',
      boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
      // color:'#4a4a4a',
      display:'block',
      padding:'.5rem',
      maxHeight:'100%',
      minHeight: 280,
      marginRight:'.5rem'
    },
    tablaContainer: {
      width: '27.5rem',
      maxHeight: '24.5rem',
      minHeight: 280,
      //minWidth:'100%',
    },
    totalEstilo:{
      fontSize:'1.25rem',
      fontWeight:'bold'
    },
    tituloEstilo:{
      paddingBottom:'.25rem',
      fontWeight:'bold'
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      }
    },
    hover: {},
    selected: {}
  });

 

export default function TablaMenor({listAv, }){    
  const classes = useStyles();      
  const [datos,setDatos] = useState([]);     
  const [registro, setRegistro] = useState([]);     
  const userId = localStorage.getItem("UsuId")?parseInt(localStorage.getItem("UsuId")):0;      
  const [modAvSecc,setModAvSecc] = useState(false);     
  const [seccion,setSeccion] = useState([]);     
  const auxCol=process.env.REACT_APP_Fondo_Color  
  useEffect(()=>{    
    
    if (listAv.usuariosMin && listAv.usuariosMin.length!==0) 
    {  
      setDatos(listAv.usuariosMin)  
    
    }
    else
    { setDatos([])
    }  
       
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listAv])          

  const onChangeTable =(regis)=>{       
    //console.log(regis);
    setSeccion(regis)
    setRegistro(regis)            
    if (userId===1) {
      setModAvSecc(true)
    }               
  }

  const celda = (alinear, estilo, contenido,index) => {
    return (
    <TableCell align={alinear} key={index} className={classes.tableCell} 
      padding={'none'} style={estilo} >
      {contenido}
    </TableCell>)
  }

  const CelTitl=({index,titulo,aline,estilo})=> celda(aline?aline:"center", {...estilo,backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 

 

  function TablaEstr(auxDatos) {        
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
    <Table stickyHeader aria-label="sticky table">
      <TableHead >    
         <TableRow>               
           <TableCell padding={'none'}   align={"center"} colSpan={4} style={{backgroundColor:auxCol,color:'white',}}> Menor Rendimiento  </TableCell>
         </TableRow>
        <TableRow>
          <CelTitl index={1} titulo={ "Nombre" } aline={"left"} estilo={{fontSize:"13px"}} />         
          <CelTitl index={2} titulo={<span>Comunas </span> } 
            aline={"center"} estilo={{fontSize:"13px"}} />   
          <CelTitl index={3} titulo={<span>Distritos <br/></span>  } 
            estilo={{fontSize:"13px"}} aline={"center"} />                         
          <CelTitl index={4} titulo={"Total" } aline={"center"} />                   
          
        </TableRow>
                         
      </TableHead>  
      <TableBody>         
      {auxDatos.map((elemnto,index) => {  
        const auxVal=seccion?.Id === elemnto.Id ?true:false                                              
        return (                  
        <TableRow className={classes.tableRow} selected={ auxVal} 
          classes={{ hover: classes.hover, selected: classes.selected }} 
          key={index+1} onClick={ () => onChangeTable(elemnto) }  
        >   
          {celda("left", {width:"9rem"}, elemnto.Nom ,index+1) }        
          {celda("center", {width:"2rem"},<NumberFormat value={ elemnto.Com} displayType={'text'}  thousandSeparator={true}/> ,index+2) }
          {celda("center", {width:"2rem"}, <NumberFormat value={ elemnto.Dto} displayType={'text'}  thousandSeparator={true}/>  ,index+3) }          
          {celda("right", {width:"4rem", paddingRight:".4rem"}, <NumberFormat value={ elemnto.Tot} displayType={'text'}  thousandSeparator={true}/>,index+5) }                    
        </TableRow>              
        );                        
      })}                                                
      </TableBody>
    </Table>
    </TableContainer>        
    ); 
  }
                       
  const llamada= datos.length !== 0 ?(TablaEstr(datos)):(<Box style={{paddingTop:1+'rem'}}>
                                  <Typography variant="h5" component="h5">No contiene datos</Typography>
                                  </Box>)
                                                                                                                                           
  return (
  <Box display={'flex'} flexDirection="row" style={{height: '18rem',marginTop:".5rem" }}>
    <Card className={classes.estiloCard} style={{height:window.innerHeight-240, textAlign:"center"}}>                        
       
      {llamada}   
    </Card>
   
  </Box>                    
  );
}